import request from 'superagent';
import Model from '../model';
import SystemModel from '/app/src/model/System/model';
import * as customerAction from './actions'
import ConversationSelector from '../Conversation/selector'
import ConversationModel from '../Conversation/model'
import { toast } from 'react-toastify';

class Customer extends Model {
    puts(customers) {
        return (dispatch) => {
            Object.keys(customers).forEach((customerId) => {
                dispatch(customerAction.setInfo(customerId, customers[customerId]));
            })
        }
    }

    updateToDB(customerId, payload){
      return (dispatch) => {
          const url = this.url()
          const token = this.token()

          request
          .put(`${url}/v1/customer/${customerId}`)
          .send(payload)
          .set('Authorization', 'Bearer ' + token)
          .accept('application/json')
          .set('Content-Type', 'application/json')
          .end((err, res) => {
              if (res.statusCode === 200)
              {
                    dispatch(customerAction.updateToDBSuccess(customerId, res.body.customer));
                    const state = this.state();
                    let room;
                    //const room = SystemSelector.getCurrentRoom(state);
                    const convo = ConversationSelector.getByRoom(state, room);
                    const convoCustomerId = ConversationSelector.getCustomerId(convo);

                    //TODO CHECK ROUTE IN THE FUTURE, ensure dashboard/conversation route
                    //HACK please, send help, we have to do this, to ensure the title is
                    // change when we update a customer name
                    if(customerId === convoCustomerId){
                        dispatch(SystemModel.setTitleFromCurrentConversation());
                    }
                    toast.success('Uppdaterat kundinformation')
              }
          });
      }
    }

    readFromDB(ids) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            // TODO:
            //ids.forEach((id) => dispatch(customerAction.readRequest(id)))
            return request
                .post(`${url}/v1/customer/get`)
                .send({ids: ids})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        res.body.map((hit) => {
                            dispatch(customerAction.setInfo(hit.customer.id, hit.customer));
                            return false;
                        });
                    } else {
                        //TODO
                        //dispatch(customerAction.readFailure(err, res))
                    }
                });
        }
    }
    readFromRawConversation(conversation){
        return (dispatch) => {
            var customer = conversation['customer']
            dispatch(customerAction.setInfo(customer.id, customer));
        }
    }
    readStatsFromDB(id) {
        return (dispatch) => {
          const url = this.url();
          const token = this.token();
          dispatch(customerAction.readStatsFromDBRequest(id))
          request
          .post(`${url}/v1/customer/stats/get`)
          .send({'customer_id': id})
          .set('Authorization', 'Bearer ' + token)
          .accept('application/json')
          .set('Content-Type', 'application/json')
          .end((err, res) => {
              if(!res) return;
              if (res.statusCode === 200) {
                  const stats = res.body.stats;
                  dispatch(customerAction.readStatsFromDBSuccess(id, stats));
              } else {
                 // TODO:
                  //dispatch(customerAction.readStatsFailure(err, res))
              }
          });
        }
    }
    // TODO: we need to change action to read requestResolvedTickets
    readResolvedTicketsFromDB(id){
      return (dispatch) => {
          const url = this.url()
          const token = this.token()
         dispatch(customerAction.readResolvedTicketsFromDBRequest(id))
         request
         .post(`${url}/v2/customer/ticket/resolved/get`)
         .send({'customer_id': id})
         .set('Authorization', 'Bearer ' + token)
         .accept('application/json')
         .set('Content-Type', 'application/json')
         .end((err, res) => {
             if (res.statusCode === 200){
                 dispatch(customerAction.readResolvedTicketsFromDBSuccess(id, res.body.tickets.room));
                 dispatch(ConversationModel.__setManyTicketPayload(res.body.tickets, 'resolved'))
             }
         });
      }
    }

    createTag(customerId, text, color){
      return (dispatch) => {
          const url = this.url()
          const token = this.token()
          var sanitizeTex = text.text.replace(/\s/g, '-');

          request
          .post(`${url}/v1/customer/${customerId}/tag/create`)
          .send({
            'text': sanitizeTex,
            'color': color
          })
          .set('Authorization', 'Bearer ' + token)
          .accept('application/json')
          .set('Content-Type', 'application/json')
          .end((err, res) => {
              if (res && res.statusCode === 200) {
                   dispatch(customerAction.createTagSuccess(customerId, res.body.tags));
            } else {
                  console.log(err, res);
          }
        });
      }
    }

    deleteTag(customerId, tagId) {
      return (dispatch) => {
        const url = this.url()
        const token = this.token()
        request
        .post(`${url}/v1/customer/${customerId}/tag/delete`)
        .send({tag_id: Number(tagId)})
        .set('Authorization', 'Bearer ' + token)
        .accept('application/json')
        .set('Content-Type', 'application/json')
        .end((err, res) => {
            if (res && res.statusCode === 200) {
                // TODO:
                //dispatch(actionAddTopNotification('Tagg borttagen.', 'success', 3));
                dispatch(customerAction.deleteTagSuccess(customerId, res.body.tags));
            }else{
                console.log(err);
            }
        });
      }
    }

    isOnline(customerId) {
        return (dispatch) => {
            dispatch(customerAction.isOnline(customerId))
        }
    }
    isOffline(customerId) {
        return (dispatch) => {
            dispatch(customerAction.isOffline(customerId))
        }
    }


    setInfo(id, info) {
        return (dispatch) => {
            dispatch(customerAction.setInfo(id, info))
        }
    }
    updateInfo(id, key, value){
        return (dispatch)=> {
            dispatch(customerAction.updateInfo(id, key, value))
        }
    }

}


export default new Customer();



// WEBPACK FOOTER //
// ./src/model/Customer/model.js